import { axios } from 'common/utils'
import { MenuAndKeyword } from 'common/types/entities/mongo/menuAndKeyword'
import { fetchAttributeByIds } from 'common/services/productAttribute'
import { Attribute } from 'common/types/entities/mongo/sub'
import { MenuBrand } from 'common/types/entities/mongo/sub/menuBrand'
import { ArrayUtils } from '@shopping/common'

export const fetchKeywordByMenuId = async (menuId: string): Promise<MenuAndKeyword> => {
  const result = await axios.get<MenuAndKeyword>(`/v1/menu-and-keywords/${menuId}`)
  return result && result.data
}

export interface BrandAndAttribute {
  menuId: string
  brands: MenuBrand[]
  attributes: Attribute[]
}

export const fetchBrandAndAttribute = async (menuId: string): Promise<BrandAndAttribute> => {
  const menuAndKeyword = await fetchKeywordByMenuId(menuId)
  const { attributes: menuAttributes = [] } = menuAndKeyword
  const ids = menuAttributes.map(attr => attr._id)
  const attributes: Attribute[] = ArrayUtils.isNotEmpty(ids) ? await fetchAttributeByIds(ids) : []
  const attributesForDisplay: Attribute[] = attributes.map(attr => {
    const displayableValueIds: string[] = menuAttributes.find(menuAttr => menuAttr._id === attr._id).valueIds
    const displayableValues = attr.values.filter(value => displayableValueIds.includes(value._id))
    return { ...attr, values: displayableValues } as Attribute
  })

  // todo : 추후 배치쪽으로 이관
  const attrResult = []
  attributesForDisplay.forEach(attr => {
    const sameNameAttrs = attributesForDisplay.filter(a => a.name === attr.name)
    if (ArrayUtils.isEmpty(sameNameAttrs)) {
      attrResult.push(attr)
    } else if (attrResult.every(a => a.name !== attr.name)) {
      const attrThatHasMaxValues = sameNameAttrs.reduce(
        (maxAttr, current) => {
          return ArrayUtils.size(current.values) > ArrayUtils.size(maxAttr.values) ? current : maxAttr
        },
        { values: [] },
      )
      ArrayUtils.isNotEmpty(attrThatHasMaxValues.values) && attrResult.push(attrThatHasMaxValues)
    }
  })

  return { menuId, brands: menuAndKeyword.brands, attributes: attrResult }
}
